"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgArrowUpIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 21 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M11.735.523a1.727 1.727 0 0 0-2.476 0L.512 9.453a1.815 1.815 0 0 0 0 2.527 1.727 1.727 0 0 0 2.477 0L8.75 6.093v17.121c0 .988.781 1.786 1.749 1.786s1.75-.798 1.75-1.786V6.093l5.761 5.882a1.727 1.727 0 0 0 2.477 0 1.815 1.815 0 0 0 0-2.528L11.74.517z' }) })));
});
exports.default = (0, react_1.memo)(SvgArrowUpIcon);
